import { useMutation, useQuery } from '@apollo/client'
import { addDays } from 'date-fns';
import dateFormat from 'functions/dateFormat';
import bcrypt from "bcryptjs";
import { GET_GLUCOSE, GET_GLUCOSE_REGISTRATION, PAGINATE_GLUCOSE, POST_GLUCOSE_MONITORING, POST_GLUCOSE_REGISTER, POST_GLUCOSE_VALIDATE } from 'queries/glucoseQueries';
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useEffect } from 'react';
import { glucoseCreator } from 'state/index';


const usePaginateGlucose = () => {
    const dispatch = useDispatch();
    const { paginateGlucose } = bindActionCreators(glucoseCreator, dispatch)

    const {
      data,
      loading,
      error,
      refetch,
      networkStatus
    } = useQuery(PAGINATE_GLUCOSE, {
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'no-cache'
    });
  
    useEffect(() => {
        if (data?.paginateGlucoseRegister) {
            paginateGlucose(data.paginateGlucoseRegister);
        }
    }, [data, paginateGlucose]);
  
    return {
      loading,
      error,
      refetch,
      networkStatus
    };
};

const useGetGlucose = (id: string) => {
    return useQuery(GET_GLUCOSE, {
        variables: {
            id
        }
    });
}

const useGetGlucoseByRegistration = (registration_number: string, cpf: string) => {
    return useQuery(GET_GLUCOSE_REGISTRATION, {
        variables: {
            registration_number,
            cpf
        }
    });
}

const useSubmitGlucoseValidate = ({ onSuccess, onError }: any) => {
    const date = dateFormat(addDays(new Date(), 200), "yyyy-MM-dd");
    const hashString = `${date}${process.env.REACT_APP_ENV}HAPVIDA_FLOWS`

    const token = bcrypt.hashSync(hashString, 10);

    return useMutation(POST_GLUCOSE_VALIDATE, {
        context: {
            headers: {
                token: token,
            }
        },
        onCompleted: (data) => {
            if(onSuccess) onSuccess(data);
        },
        onError: (error) => {
            if(onError) onError(error);
        }
    })
}

const useSubmitGlucoseRegister = ({ onSuccess, onError }: any) => {
    const date = dateFormat(addDays(new Date(), 200), "yyyy-MM-dd");
    const hashString = `${date}${process.env.REACT_APP_ENV}HAPVIDA_FLOWS`

    const token = bcrypt.hashSync(hashString, 10);

    return useMutation(POST_GLUCOSE_REGISTER, {
        context: {
            headers: {
                token: token,
            }
        },
        onCompleted: (data) => {
            if(onSuccess) onSuccess(data);
        },
        onError: (error) => {
            if(onError) onError(error);
        }
    })
}

const useSubmitGlucoseMonitoring = ({ onSuccess, onError }: any) => {
    const date = dateFormat(addDays(new Date(), 200), "yyyy-MM-dd");
    const hashString = `${date}${process.env.REACT_APP_ENV}HAPVIDA_FLOWS`

    const token = bcrypt.hashSync(hashString, 10);

    return useMutation(POST_GLUCOSE_MONITORING, {
        context: {
            headers: {
                token: token,
            }
        },
        onCompleted: (data) => {
            if(onSuccess) onSuccess(data);
        },
        onError: (error) => {
            if(onError) onError(error);
        }
    })
}

export {
    usePaginateGlucose,
    useGetGlucose,
    useGetGlucoseByRegistration,
    useSubmitGlucoseValidate,
    useSubmitGlucoseRegister,
    useSubmitGlucoseMonitoring
}